module.exports = __webpack_public_path__ + "static/media/4d8715abb531ada4bcacf59e0fe30133.ab4958a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/4d8715abb531ada4bcacf59e0fe30133.jpg
// module id = 291
// module chunks = 0